export default __webpack_public_path__ + "img/whatNews2.901454c0.jpg";